import ModelFactory from 'business/models/ModelFactory';
import { PuckClient, PuckDTO } from 'business/models/Models';
import BaseService from './BaseService';

export default class PuckService extends BaseService {
  async getAllPucksWithOccupancyByTripId(tripId: number): Promise<PuckDTO[]> {
    const _puckService: PuckClient = ModelFactory(PuckClient);
    return await _puckService.getAllPucksWithOccupancyByTripId(tripId);
  }
}
